import { AfterViewInit, Directive, effect, ElementRef, HostListener, inject, input, Renderer2 } from '@angular/core';
import { DropdownDirective } from './dropdown.directive';


@Directive({
    selector: 'button[dropdownToggle]'
})
export class DropdownToggleDirective implements AfterViewInit {

    showIcon = input(false, { alias: 'dropdownToggle' });

    @HostListener('click')
    toggle() {
        this.dropdown.isOpen.update(open => !open);
    }

    private dropdown = inject(DropdownDirective);

    private elementRef = inject(ElementRef);

    private renderer = inject(Renderer2);

    private icon: HTMLElement;

    constructor() {
        const el = this.elementRef.nativeElement as HTMLButtonElement;
        this.icon = this.renderer.createElement('i');
        this.renderer.addClass(this.icon, 'fa');
        if (el.textContent?.trim() != '') {
            this.renderer.addClass(this.icon, 'ml-1');
        }
        this.renderer.addClass(el, 'text-nowrap');

        effect(() => {
            if (!this.showIcon()) {
                return;
            }
            if (this.dropdown.isOpen()) {
                this.renderer.removeClass(this.icon, 'fa-caret-down');
                this.renderer.addClass(this.icon, 'fa-caret-up');
                this.renderer.addClass(el, 'active');
            } else {
                this.renderer.removeClass(this.icon, 'fa-caret-up');
                this.renderer.addClass(this.icon, 'fa-caret-down');
                this.renderer.removeClass(el, 'active');
            }
        });
    }

    ngAfterViewInit() {
        this.renderer.appendChild(this.elementRef.nativeElement, this.icon);
    }
}
